<template>
  <div>
    <h1 v-if="creatingNewVariation" class="headline-1 mx-12">
      Create as new variation
    </h1>
    <v-layout align-center justify-center>
      <v-card width="800">
        <v-card-title class="headline footer" primary-title>
          The new SKU
        </v-card-title>
        <v-card-text>
          <div class="px-8 py-4">
            <v-row>
              <v-col class="py-2">
                <h4 class="basic--text">
                  The new SKU for this item is: {{ newSKUValue }}
                </h4>
                <h4 class="basic--text">
                  Please, print the label you see below, put it on the item and
                  put the item back to the box.
                </h4>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="10">
                <h1
                  class="heading-1 text-center basic--text"
                  style="font-size: 3rem"
                >
                  {{ newSKUValue }}
                </h1>
                <input type="hidden" id="sku" :value="newSKUValue" />
              </v-col>
              <v-col cols="2"
                ><v-btn @click="copyText" outlined
                  >Copy
                  <v-icon right size="30" v-if="copySuccess" color="green"
                    >mdi-clipboard-check-outline</v-icon
                  >
                  <v-icon right size="30" v-if="copyFailed" color="red"
                    >mdi-clipboard-remove-outline</v-icon
                  >
                  <v-icon right size="30" v-if="!copySuccess && !copyFailed"
                    >mdi-clipboard-plus-outline</v-icon
                  >
                </v-btn></v-col
              >
            </v-row>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#66BB6A" @click="reset"> Continue </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </div>
</template>
<script>
export default {
  name: "NewSkuCard",
  props: {
    creatingNewVariation: Boolean,
    newSKUValue: String,
  },
  data: () => ({
    copySuccess: false,
    copyFailed: false,
  }),
  methods: {
    reset() {
      // this.$router.go();
      this.$emit("continueNewSKU");
    },
    copyText() {
      let testingCodeToCopy = document.querySelector("#sku");
      testingCodeToCopy.setAttribute("type", "text");
      testingCodeToCopy.select();
      try {
        document.execCommand("copy");
        this.copySuccess = true;
      } catch (err) {
        this.copyFailed = true;
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
};
</script>